import { SyncJobsActionTypes } from './constants';
import { PAGINATION_DEFAULT_VALUE } from '../../helpers/defaultValue';

const INIT_STATE = {
    loadingSyncJobs: false,
    error: null,
    syncJobs: null,
    pagination: PAGINATION_DEFAULT_VALUE,
};

type SyncJobsAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};

//TODO: define data type for syncJobs
type State = { error?: null, syncJobs: any, pagination: any };

const SyncJobs = (state: State = INIT_STATE, action: SyncJobsAction): any => {
    //console.log(action);
    switch (action.type) {
        case SyncJobsActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case SyncJobsActionTypes.GET_ALL_SYNC_JOBS: {
                    return {
                        ...state,
                        loadingSyncJobs: false,
                        syncJobs: action.payload.data.syncJobs,
                        pagination: { ...PAGINATION_DEFAULT_VALUE, ...action.payload.data.pagination },
                    };
                }
                default:
                    return { ...state, loadingSyncJobs: false };
            }

        case SyncJobsActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case SyncJobsActionTypes.GET_ALL_SYNC_JOBS:
                    return { ...state, loadingSyncJobs: false, error: action.payload.error };
                default:
                    return { ...state, loadingSyncJobs: false };
            }

        case SyncJobsActionTypes.GET_ALL_SYNC_JOBS:
            return { ...state, loadingSyncJobs: true, syncJobs: null };
        case SyncJobsActionTypes.RESET_ALL_SYNC_JOBS_ERRORS:
            return { ...state, error: null };
        default:
            return { ...state };
    }
};

export default SyncJobs;
